import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import useState from 'react-usestateref'
//import VideoModal from './VideoModal';

const InstructionalVideosContainer = ({ containerObject, templateName, contentId, dataZone }) => {
    const [instructionalVideoList, setInstructionalVideoList] = useState(containerObject && containerObject.articles ? containerObject.articles : "")
    const [videosPerPage, setVideosPerPage] = useState(containerObject && containerObject.attributes.viewSize ? containerObject.attributes.viewSize :"")
    const [currentPage, setCurrentPage, currentPageRef] = useState(1)
    const [videoLinkUrl, setVideoLinkUrl, currentVideoLinkUrl] = useState()
    
    const handleVideoModal = (event) => {
        var videoUrl = event.currentTarget.getAttribute('data-val');
        var instructionalVideoIframeEle = document.getElementById("instructional-video-iframe")
        instructionalVideoIframeEle.src = videoUrl
    }
    const handleClick = (event) => {
        setCurrentPage(Number(event.currentTarget.id))
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [currentPage])


    const indexOfLastTodo = currentPageRef.current * videosPerPage;
    const indexOfFirstTodo = indexOfLastTodo - videosPerPage;
    const currentInstructionalVideoList = instructionalVideoList.slice(indexOfFirstTodo, indexOfLastTodo);

    const getMediaUrl = (url, mediaType) => {
        var match;
        match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/);
        if (match && match[2].length === 11) {
            if (mediaType == "video") {
                return `https://www.youtube.com/embed/${match[2]}?autoplay=1`
            } else if (mediaType == "image") {
                return `https://img.youtube.com/vi/${match[2]}/hqdefault.webp`
            }
        } else if (mediaType == "video") {
            return url;
        } else if (mediaType == "image") {
            return `https://img.youtube.com/vi/6wL1RD_bS3M/mqdefault.webp`
        }
    }

    const renderInstructionalVideoList = currentInstructionalVideoList.map((jsondata) => {
        return (
            <div className={`col-md-4 col-lg-6 col-12 mb-3 ${jsondata.attributes.class}`}>
                <div className="img-thumbnail p-3">
                <div className="video-desc">
                        <h4> {jsondata.attributes.videoTitle ? jsondata.attributes.videoTitle : ""} </h4>
                        <h6> {jsondata.attributes.videoDuration ? jsondata.attributes.videoDuration : ""} </h6>
                    </div>
                    <Link  data-val={getMediaUrl(jsondata.attributes.linkUrl, "video")} onClick={handleVideoModal} >
                        <div class="modal-body row justify-content-center">
                        <iframe 
                            id="instructional-video-iframe"
                            src={getMediaUrl(jsondata.attributes.linkUrl,"video")}
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                        
                    </div>
                    </Link>
                    
                </div>
            </div>
        )
    });
    // Logic for displaying page numbers
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(instructionalVideoList.length / videosPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <>
            {/* <VideoModal></VideoModal> */}
            <div className={`row vast-plugin-content gx-0 ${containerObject.attributes.class}`} data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} >
                {renderInstructionalVideoList}
            </div>
        </>
    )
}

export default InstructionalVideosContainer